module.exports = __webpack_public_path__ + "static/media/5-hybrid.1fed063b.png";